/** @flow */

import {
  GetAbsenceMonitoringList,
  GetAbsenceMonitoringListSuccess,
  GetAbsenceMonitoringListError,
  GetAbsenceMonitoring,
  GetAbsenceMonitoringSuccess,
  GetAbsenceMonitoringError,
  GetAbsenceMonitoringSchema,
  GetAbsenceMonitoringSchemaSuccess,
  GetAbsenceMonitoringSchemaError,
  NewAbsenceMonitoring,
  DuplicateAbsenceMonitoringSuccess,
  StartDraftAbsenceMonitoringSuccess,
  SetAbsenceMonitoringDraft,
  NewAbsenceMonitoringAssignments,
  SetAbsenceMonitoringAssignments,
  SetAbsenceMonitoringEnabled,
  SetAbsenceMonitoringStatus,
  SetAbsenceMonitoringModalStep,
  SetShowAddAbsenceMonitoringModal,
  SetShowEditAbsenceMonitoringModal,
  SetShowEditAbsenceMonitoringAssignmentsModal,
  SetShowDiscardAbsenceMonitoringModal,
  SetShowSubmitAbsenceMonitoringModal,
  SetShowDisableAbsenceMonitoringModal,
  SetShowCancelAbsenceMonitoringModal,
  SetShowCancelDiscardAbsenceMonitoringModal,
  SetAbsenceMonitoringDraftAssignments,
  UpdateAbsenceMonitoring,
  UpdateAbsenceMonitoringSuccess,
  UpdateAbsenceMonitoringError,
} from "@modules/service/constants/actions";
import * as absenceMonitoringReducers from "./reducers";
import initialState from "./state";
import type { AbsenceMonitoringState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: AbsenceMonitoringState = initialState,
  action: Object,
): AbsenceMonitoringState => {
  const act = {
    [UpdateAbsenceMonitoring]: absenceMonitoringReducers.onUpdateAbsenceMonitoring,
    [UpdateAbsenceMonitoringSuccess]: absenceMonitoringReducers.onUpdateAbsenceMonitoringSuccess,
    [UpdateAbsenceMonitoringError]: absenceMonitoringReducers.onUpdateAbsenceMonitoringError,

    [GetAbsenceMonitoringList]: absenceMonitoringReducers.onGetAbsenceMonitoringList,
    [GetAbsenceMonitoringListSuccess]: absenceMonitoringReducers.onGetAbsenceMonitoringListSuccess,
    [GetAbsenceMonitoringListError]: absenceMonitoringReducers.onGetAbsenceMonitoringListError,

    [GetAbsenceMonitoring]: absenceMonitoringReducers.onGet,
    [GetAbsenceMonitoringSuccess]: absenceMonitoringReducers.onGetSuccess,
    [GetAbsenceMonitoringError]: absenceMonitoringReducers.onGetError,
    [GetAbsenceMonitoringSchema]: absenceMonitoringReducers.onGetSchema,
    [GetAbsenceMonitoringSchemaSuccess]: absenceMonitoringReducers.onGetSchemaSuccess,
    [GetAbsenceMonitoringSchemaError]: absenceMonitoringReducers.onGetSchemaError,
    [NewAbsenceMonitoring]: absenceMonitoringReducers.onNew,
    [DuplicateAbsenceMonitoringSuccess]: absenceMonitoringReducers.onDuplicateSuccess,
    [StartDraftAbsenceMonitoringSuccess]: absenceMonitoringReducers.onStartDraftSuccess,
    [SetAbsenceMonitoringDraft]: absenceMonitoringReducers.onSetDraft,
    [NewAbsenceMonitoringAssignments]: absenceMonitoringReducers.onNewAssignments,
    [SetAbsenceMonitoringAssignments]: absenceMonitoringReducers.onSetAssignments,
    [NewAbsenceMonitoringAssignments]: absenceMonitoringReducers.onNewAssignments,
    [SetAbsenceMonitoringDraftAssignments]:
      absenceMonitoringReducers.onSetAbsenceMonitoringDraftAssignments,
    [SetAbsenceMonitoringEnabled]: absenceMonitoringReducers.onSetEnabled,
    [SetAbsenceMonitoringStatus]: absenceMonitoringReducers.onSetStatus,
    [SetAbsenceMonitoringModalStep]: absenceMonitoringReducers.onSetModalStep,
    [SetShowAddAbsenceMonitoringModal]: absenceMonitoringReducers.onSetShowAddModal,
    [SetShowEditAbsenceMonitoringModal]: absenceMonitoringReducers.onSetShowEditModal,
    [SetShowEditAbsenceMonitoringAssignmentsModal]:
      absenceMonitoringReducers.onSetShowEditAssignmentsModal,
    [SetShowDiscardAbsenceMonitoringModal]: absenceMonitoringReducers.onSetShowDiscardModal,
    [SetShowSubmitAbsenceMonitoringModal]: absenceMonitoringReducers.onSetShowSubmitModal,
    [SetShowDisableAbsenceMonitoringModal]: absenceMonitoringReducers.onSetShowDisableModal,
    [SetShowCancelAbsenceMonitoringModal]: absenceMonitoringReducers.onSetShowCancelModal,
    [SetShowCancelDiscardAbsenceMonitoringModal]:
      absenceMonitoringReducers.onSetShowCancelDiscardModal,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
